import {
	ModalBackground,
	default as Modal,
	ModalContent,
} from 'packages/kakapo-ui-kit/components/modals/Modal';
import { useTranslation } from 'react-i18next';

import { useHistory } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';
import { CompetencyLevelSetCreator } from 'packages/kakapo-ui-settings-application/pages/evaluations/competency-level-sets/CompetencyLevelSetEditor';
import ModalHeader, {
	ModalHeaderTitle,
} from 'packages/kakapo-ui-kit/components/modals/ModalHeader';

export default function CompetencyLevelSetModal(props: {
	returnUrl: string;
	set?: graphql.CompetencyLevelSet;
	onSave: (set: graphql.CompetencyLevelSet) => void;
}) {
	const { t } = useTranslation();
	const history = useHistory();

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader returnUrl={props.returnUrl}>
					<ModalHeaderTitle>
						{t(`common.settings.competencyLevelSets.${props.set ? 'edit' : 'create'}.title`)}
					</ModalHeaderTitle>
				</ModalHeader>
				<ModalContent>
					<CompetencyLevelSetCreator
						set={props.set}
						onSave={(set) => {
							props.onSave(set);
							history.push(props.returnUrl);
						}}
					/>
				</ModalContent>
			</Modal>
		</ModalBackground>
	);
}
